import { Box, Card, CardHeader, CardBody, Heading } from "@chakra-ui/react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useCallback } from "react";
import { useNavigateToList } from "@/hooks/useNavigateToList";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { SendCustomEmailForm } from "@/components/forms/SendCustomEmailForm";
import { shippingLineNameFromSearchParams } from "@/lib/navigation/financialStatementsSearchParams";

export default function SendCustomEmailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = useParams<{ shippingLineId: string }>();
  const shippingLineId = params.shippingLineId;
  const navigateToList = useNavigateToList(
    shippingLineId
      ? `/shipping-lines/financial-statements/${shippingLineId}`
      : '/shipping-lines',
  )
  const shippingLineName = shippingLineNameFromSearchParams(searchParams);

  const goBack = useCallback(() => {
    if (shippingLineId) {
      navigateToList();
      return;
    }
    navigate("/shipping-lines");
  }, [navigate, navigateToList, shippingLineId]);

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Send Email
            </Heading>
          </CardHeader>
          <CardBody>
            <SendCustomEmailForm
              shippingLineName={shippingLineName}
              onSuccess={goBack}
              onCancel={goBack}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  );
}
